let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("cSqBE")).then(() => parcelRequire('2BKdT'));